// extracted by mini-css-extract-plugin
export default {"grid":"ExactaField_grid__iYksC","boxed":"ExactaField_boxed__r+HfY"};